import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import SharedPageWrapper from '../SharedPageWrapper/SharedPageWrapper';

function ProfileLayout({ auth }) {
  const location = useLocation();
  const [currentGame, setCurrentGame] = useState(location.state?.from || 'world');
  
  // Update game context when location state changes
  useEffect(() => {
    if (location.state?.from) {
      setCurrentGame(location.state.from);
    } else if (location.state?.userCups) {
      // Smart default: determine based on which cups the user has
      const { hasWorldCups, hasMk8dxCups } = location.state.userCups;
      if (hasWorldCups && !hasMk8dxCups) {
        setCurrentGame('world');
      } else if (hasMk8dxCups && !hasWorldCups) {
        setCurrentGame('mk8dx');
      } else {
        // Both or neither: default to world
        setCurrentGame('world');
      }
    }
  }, [location.state]);

  return (
    <SharedPageWrapper game={currentGame}>
      <Header currentGame={currentGame} />
      <Outlet context={[auth, setCurrentGame]} />
      <Footer />
    </SharedPageWrapper>
  );
}

export default ProfileLayout;
